var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLiveNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6728FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.817 8.549a2.625 2.625 0 0 1 .166 5.245l-.166.005v-1.25a1.375 1.375 0 0 0 .132-2.744l-.132-.006v-1.25zM10.917 8.174v5.417H7.5a1 1 0 0 1-1-1V9.174a1 1 0 0 1 1-1h3.417zm-1.251 1.25H7.75v2.916h1.916V9.423z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.228 5.553a1 1 0 0 1 .105.447v9.324a1 1 0 0 1-1.394.92L9.75 13.59V8.174l6.136-3.068a1 1 0 0 1 1.342.447zm-1.145.851L11 8.946v3.82l5.083 2.18V6.403z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 12.882v4.375h.75v-3.375h1.25v3.5c0 .58-.439 1.058-1.002 1.119l-.123.006h-1c-.58 0-1.057-.439-1.118-1.002l-.007-.123v-4.5h1.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLiveNotice);
export default __webpack_public_path__ + "static/media/ic_live_notice.917c1f66694a0767accbfd5950a48240.svg";
export { ForwardRef as ReactComponent };